module.exports = __webpack_public_path__ + "img/Katelynn-Signature.e84f2543.svg";